// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1t8ox","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Nr4a"};